import { chainValidations, makeFormStateWithModel } from 'formtastisch'
import { type IntlShape } from 'react-intl'

import { validateEmail, validateRequired } from '../base-form-handling'

// TypeScript type inference is preferred here for maintainability and to ensure the return type always matches the implementation. If the implementation changes, the type will update automatically.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types -- see above
export const makeForgotPasswordFormState = (intl: IntlShape) => {
  return makeFormStateWithModel({
    initialData: {
      email: '',
      fcSolution: '',
    },
    validations: {
      email: (value) => {
        return chainValidations(
          () =>
            validateRequired(
              value,
              intl.formatMessage({ id: 'form.error.input.missing' }),
            ),

          () =>
            validateEmail(
              value,
              intl.formatMessage({ id: 'error.email.invalid' }),
            ),
        )
      },
    },
  })
}

export type ForgotPasswordFormState = ReturnType<
  typeof makeForgotPasswordFormState
>
